<template>
  <div class="MusicExam">
      音乐考级
      <footerTabber />
  </div>
</template>

<script>
import footerTabber from '@/components/footerTabber.vue'
export default {
components: {
    footerTabber
  }
}
</script>

<style scoped>

</style>